module.exports = __webpack_public_path__ + "static/media/paintCanCorrect.1bfb71e4.png";